/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LinkLearnerDto { 
    /**
     * ID of the learner to link
     */
    learnerId: number;
    type: LinkLearnerDto.TypeEnum;
}
export namespace LinkLearnerDto {
    export const TypeEnum = {
        Father: 'FATHER',
        Mother: 'MOTHER',
        Guardian: 'GUARDIAN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


